<template>
  <div class="content-box">
    <div class="contant-wrap content-body">
      <el-card>
        <el-form :inline="true" :model="queryForm">
          <el-form-item label="关键字">
            <el-input
              v-model="queryForm.drugName"
              placeholder="药品名称/条形码"
            ></el-input>
          </el-form-item>
          <el-form-item label="药品类型">
            <el-select
              v-model="queryForm.drugType"
              placeholder="药品类型"
              class="select-input"
              @change="selectChange"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="药品状态">
            <el-select
              v-model="queryForm.status"
              placeholder="药品状态"
              class="select-input"
              @change="selectChange"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="匹配状态">
            <el-select
              v-model="queryForm.hiMapStas"
              placeholder="匹配状态"
              class="select-input"
              @change="selectChange"
            >
              <el-option
                v-for="item in hiStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="getList(queryForm)"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
        <div>
          <el-button
            @click="updateDrug('add', '')"
            icon="el-icon-plus"
            type="primary"
            size="small"
          >
            新增药品
          </el-button>
          <el-button
            @click="downloadTemplate"
            icon="el-icon-download"
            type="primary"
            size="small"
          >
            下载模板
          </el-button>
          <el-upload
            :action="importUrl"
            :on-preview="handlePreview"
            :before-remove="beforeRemove"
            :on-success="uploadSuccess"
            :multiple="false"
            :on-exceed="handleExceed"
            :file-list="fileList"
            :before-upload="beforeUpload"
            accept=".xlsx"
            :with-credentials="true"
            :show-file-list="false"
            class="upload-btn"
          >
            <el-button
              type="primary"
              class="button"
              icon="el-icon-sort-up"
              size="small"
              >导入</el-button
            >
          </el-upload>
          <el-button
            type="primary"
            class="button"
            @click="fileExport"
            icon="el-icon-sort-down"
            size="small"
            >导出</el-button
          >
          <el-button
            type="primary"
            class="button"
            @click="autoMatchDrug"
            size="small"
            >医保匹配</el-button
          >
        </div>
        <el-table
          :data="tableData"
          border
          height="calc(100vh - 330px)"
          :header-cell-style="{ 'font-weight': 'bold', background: '#faf9f9' }"
          style="width: 100%; margin-top: 20px"
          v-loading="loading"
        >
          <el-table-column
            label="药品名称"
            prop="commonName"
            width="160"
            fixed
          ></el-table-column>
          <el-table-column
            label="药品类型"
            prop="drugTypeLabel"
            width="80"
            fixed
          ></el-table-column>
          <el-table-column
            label="药品规格"
            prop="specification"
            width="90"
            fixed
          ></el-table-column>
          <el-table-column
            label="厂家"
            prop="manufacturer"
            width="180"
            fixed
          ></el-table-column>
          <el-table-column
            label="批准文号"
            prop="approvalNumber"
            width="120"
            fixed
          ></el-table-column>
          <el-table-column
            label="医保匹配状态"
            prop="hiMapStas"
            width="120"
          ></el-table-column>
          <el-table-column
            label="医保编码"
            prop="hiMedListCodg"
            width="180"
          ></el-table-column>
          <el-table-column
            label="条形码"
            prop="barCode"
            width="180"
          ></el-table-column>
          <el-table-column
            label="使用次数"
            prop="useNumber"
            width="180"
          ></el-table-column>
          <el-table-column label="药品状态" prop=" status" width="180">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status == 1" type="success">启用</el-tag>
              <el-tag v-if="scope.row.status == 2" type="danger">禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="160"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="editBarCode(scope.row)"
                v-if="scope.row.useNumber > 0"
                :disabled="scope.row.status == 2"
                >条形码</el-button
              >
              <el-button
                type="text"
                @click="updateDrug('edit', scope.row)"
                v-else
                :disabled="scope.row.status == 2"
                >编辑</el-button
              >
              <el-button
                type="text"
                v-if="scope.row.status == 2"
                @click="deleteDrug(scope.row)"
                :disabled="scope.row.useNumber != 0"
                >启用</el-button
              >
              <el-button
                type="text"
                v-else
                @click="deleteDrug(scope.row)"
                :disabled="scope.row.useNumber != 0"
                >禁用</el-button
              >
              <el-button type="text" @click="checkDrug('check', scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="queryForm.currentPage"
            :page-sizes="pageSizes"
            :page-size.sync="queryForm.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
        <el-dialog
          title="编辑"
          :visible.sync="barCodeDialog"
          width="30%"
          :close-on-click-modal="false"
        >
          <el-form
            :model="barCodeForm"
            :rules="barCodeRules"
            ref="barCodeForm"
            class="demo-ruleForm"
          >
            <el-form-item label="药品ID：" style="display: flex">
              {{ barCodeForm.id }}
            </el-form-item>
            <el-form-item label="条形码：" style="display: flex" prop="barCode">
              <el-input
                v-model="barCodeForm.barCode"
                placeholder="请输入条形码"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="barCodeDialog = false" size="small"
              >取 消</el-button
            >
            <el-button type="primary" @click="editBarCodeConfirm" size="small"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </el-card>
    </div>
  </div>
</template>

<script>
import { pageSizes } from "@/config/constant";
import config from "@/config/index";

export default {
  name: "standardDrug",
  data() {
    return {
      tableData: [], //列表数据
      totalCount: 0, //总条数
      pageSizes,
      loading: false,
      queryForm: {
        currentPage: 1, //当前页数
        pageSize: 20, //每页条数
        drugName: "",
        drugType: "-1",
        status: "1", //1：启用 2：禁用
        hiMapStas: "-1", // 医保药品匹配状态
      },
      typeOptions: [
        {
          label: "全部",
          value: "-1",
        },
        {
          label: "西药",
          value: "1",
        },
        {
          label: "中药饮片",
          value: "2",
        },
        {
          label: "中成药",
          value: "3",
        },
        {
          label: "保健品",
          value: "4",
        },
        {
          label: "医疗器械",
          value: "5",
        },
        {
          label: "化妆品",
          value: "6",
        },
        {
          label: "日用百货",
          value: "7",
        },
        {
          label: "其它",
          value: "8",
        },
        {
          label: "贴敷中药",
          value: "9",
        },
        {
          label: "检查治疗项",
          value: "10",
        },
        {
          label: "附加费用",
          value: "11",
        },
      ],
      statusOptions: [
        {
          label: "全部",
          value: "-1",
        },
        {
          label: "启用",
          value: "1",
        },
        {
          label: "禁用",
          value: "2",
        },
      ],
      hiStatusOptions: [
        {
          label: "全部",
          value: "-1",
        },
        {
          label: "未匹配",
          value: "0",
        },
        {
          label: "已匹配",
          value: "1",
        },
        // {
        //   label:'未匹配',
        //   value:'2'
        // },
      ],
      importUrl: `${config.host}/drugsManage/drugs/new/uploadDrugStandTemplate`, // 导入药品信息URL
      fileList: [], // 上传文件的数组
      barCodeDialog: false, //条形码弹窗
      barCodeForm: {
        id: "",
        barCode: "",
      },
      barCodeRules: {
        barCode: [{ required: true, message: "请输入条形码", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.getList(this.queryForm);
  },
  methods: {
    // 获取列表
    getList(obj) {
      // this.loading = true;
      this.$api.systemSet.getDrugListAPI(obj).then((res) => {
        console.log(res,'res')
        this.tableData = res.records;
        this.totalCount = res.total;
      });
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.getList(this.queryForm);
    },
    handleCurrentChange(val) {
      this.queryForm.currentPage = val;
      this.getList(this.queryForm);
    },
    updateDrug(type, item) {
      this.$router.push({
        path: "/system/standardDrugDetail",
        query: { type: type, id: item.idStr },
      });
    },
    editBarCode(item) {
      this.barCodeDialog = true;
      this.$set(this.barCodeForm, "id", item.idStr);
    },
    editBarCodeConfirm() {
      this.$api.systemSet.editBarCodeAPI(this.barCodeForm).then((res) => {
        // console.log(res)
        this.$message({
          type: "success",
          message: "修改成功!",
        });
        this.getList(this.queryForm);
        this.barCodeDialog = false;
        this.$refs["barCodeForm"].resetFields();
      });
    },
    checkDrug(type, item) {
      this.$router.push({
        path: "/system/standardDrugDetail",
        query: { type: type, id: item.idStr },
      });
    },
    deleteDrug(item) {
      // console.log(item,'item');
      this.$confirm("此操作将修改该药品状态, 是否继续?", "友情提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const params = {
            id: item.idStr,
            status: item.status == 1 ? 2 : 1,
          };
          this.$api.systemSet.deleteDrugAPI(params).then((res) => {
            // console.log(res)
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            this.getList(this.queryForm);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    selectChange() {
      this.queryForm.currentPage = 1;
      // console.log(this.queryForm,'queryForm');
    },
    // 下载模板
    downloadTemplate() {
      this.$api.systemSet.downloadTemplateAPI().then((res) => {
        // console.log(res)
      });
    },
    // 点击文件上传时二次确认
    handlePreview(file) {
      return this.$message.success(`${file.name} 已上传成功`);
    },
    // 上传移除文件时确认
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}?`);
    },
    // 文件上传成功
    uploadSuccess(file, fileList) {
      const files = JSON.parse(fileList.response);
      // console.log('测试', fileList);
      // console.log('测试', files);
      // let arr = '';
      if (files.errorCode === 0) {
        this.fileList.push({
          name: files.name,
          url: files.data[0],
        });
        // this.$message.success(`${fileList.name}+上传成功`);
        this.$message.success(files.data);
        this.getList(this.queryForm);
      } else {
        this.$message.error(`上传失败!${files.errorMsg}`);
        // console.log(file);
        this.fileList.pop();
      }
    },
    // 上传文件超出限制时的操作
    handleExceed(file) {
      this.$message.warning(
        `当前上传限制选择 1 个文件，本次选择了 ${file.length} 个文件`
      );
    },
    // 上传文件时的校验
    beforeUpload(file) {
      const reg = /\.xlsx$/;
      if (reg.test(file.name)) {
        // console.log('格式正确');
      } else {
        this.$message({
          type: "error",
          message: "上传文件格式需为.xlsx文件！",
        });
      }
    },
    // 导出
    fileExport() {
      if (this.tableData.length < 1) {
        this.$alert("没有药品信息，请更换查询条件试试", "友情提示", {
          confirmButtonText: "确定",
        }).catch(() => {});
      } else {
        this.$api.systemSet.exportDrugAPI(this.queryForm);
      }
    },
    // 医保匹配
    autoMatchDrug() {
      this.$api.newInsurance.autoMatchDrugAPI().then((res) => {
        // console.log(res)
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: "匹配成功!",
          });
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.select-input {
  width: 180px;
}
.upload-btn {
  display: inline-block;
  margin: 0 10px;
}
</style>